/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_Auth_TitleInputs */

const en_landing_features_auth_title = /** @type {(inputs: Landing_Features_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication`)
};

const zh_landing_features_auth_title = /** @type {(inputs: Landing_Features_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身份认证`)
};

/**
* | output |
* | --- |
* | "Authentication" |
*
* @param {Landing_Features_Auth_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_auth_title = /** @type {((inputs?: Landing_Features_Auth_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_Auth_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_auth_title(inputs)
	return zh_landing_features_auth_title(inputs)
});
export { landing_features_auth_title as "landing.features.auth.title" }